<div class="spacerWrapper" fxLayout="column">
    <h2 mat-dialog-title class="dialogTitle">{{ title }}</h2>

    <div mat-dialog-content>
        <form [formGroup]="schoolEditorForm">
            <div class="inputContainer">
                <label>SchoolName</label>
                <mat-form-field appearance="outline">
                    <input #schoolName matInput type="text" formControlName="SchoolName" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Center</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Center" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Route</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Route" />
                </mat-form-field>
            </div>

            <div class="phoneContainer">
                <div class="inputContainer phone">
                    <label>Phone</label>
                    <mat-form-field appearance="outline">
                        <input matInput type="text" formControlName="Phone" />
                    </mat-form-field>
                </div>

                <div class="inputContainer phoneExt">
                    <label>Ext.</label>
                    <mat-form-field appearance="outline">
                        <input matInput type="text" formControlName="PhoneExt" />
                    </mat-form-field>
                </div>
            </div>

            <div class="inputContainer">
                <label>_5digit</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="_5digit" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Fax</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Fax" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>_5digit2</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="_5digit2" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Grades</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Grades" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Area</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Area" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Principal</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Principal" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>StreetAddress</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="StreetAddress" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>City</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="City" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Zip</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Zip" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Doegrade1213</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Doegrade1213" />
                </mat-form-field>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="PreK" aria-label="PK"></mat-checkbox>
                <label> PK</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Elem" aria-label="Elem"></mat-checkbox>
                <label> Elem</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Mid" aria-label="Mid"></mat-checkbox>
                <label> Mid</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Sr" aria-label="Sr"></mat-checkbox>
                <label> Sr</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Tech" aria-label="Tech"></mat-checkbox>
                <label> Tech</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Arts" aria-label="Arts"></mat-checkbox>
                <label> Arts</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Adult" aria-label="Adult"></mat-checkbox>
                <label> Adult</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Ese" aria-label="Ese"></mat-checkbox>
                <label> Ese</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Charter" aria-label="Charter"></mat-checkbox>
                <label> Charter</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Choice" aria-label="Choice"></mat-checkbox>
                <label> Choice</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Magnet" aria-label="Magnet"></mat-checkbox>
                <label> Magnet</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Ib" aria-label="Ib"></mat-checkbox>
                <label> Ib</label>
            </div>

            <div class="inputContainer">
                <label>Link</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Link" />
                </mat-form-field>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="TwoMaps" aria-label="TwoMaps"></mat-checkbox>
                <label> TwoMaps</label>
            </div>

            <div class="inputContainer">
                <label>PrimaryFunc</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="PrimaryFunc" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Doegrade1112</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Doegrade1112" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>EnrollmentPrev</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="EnrollmentPrev" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>EnrollmentCurrent</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="EnrollmentCurrent" />
                </mat-form-field>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Title1" aria-label="Title1"></mat-checkbox>
                <label> Title1</label>
            </div>

            <div class="inputContainer">
                <label>Bell1</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Bell1" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Bell2</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Bell2" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Misc1</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Misc1" />
                </mat-form-field>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="GKg" aria-label="GKg"></mat-checkbox>
                <label> GKg</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G01" aria-label="G01"></mat-checkbox>
                <label> G01</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G02" aria-label="G02"></mat-checkbox>
                <label> G02</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G03" aria-label="G03"></mat-checkbox>
                <label> G03</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G04" aria-label="G04"></mat-checkbox>
                <label> G04</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G05" aria-label="G05"></mat-checkbox>
                <label> G05</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G06" aria-label="G06"></mat-checkbox>
                <label> G06</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G07" aria-label="G07"></mat-checkbox>
                <label> G07</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G08" aria-label="G08"></mat-checkbox>
                <label> G08</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G09" aria-label="G09"></mat-checkbox>
                <label> G09</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G10" aria-label="G10"></mat-checkbox>
                <label> G10</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G11" aria-label="G11"></mat-checkbox>
                <label> G11</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G12" aria-label="G12"></mat-checkbox>
                <label> G12</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="G31" aria-label="G31"></mat-checkbox>
                <label> G31</label>
            </div>

            <div class="inputContainer">
                <label>District</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="District" />
                </mat-form-field>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="Programs" aria-label="Programs"></mat-checkbox>
                <label> Programs</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="NextYearMap" aria-label="NextYearMap"></mat-checkbox>
                <label> NextYearMap</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="NextYearTwoMap" aria-label="NextYearTwoMap"></mat-checkbox>
                <label> NextYearTwoM</label>
            </div>

            <div class="inputContainer">
                <label>MapAddress</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="MapAddress" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>SchoolPhotoUrl</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="SchoolPhotoUrl" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Latitude</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Latitude" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Longitude</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Longitude" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>PrevSchoolName</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="PrevSchoolName" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>DoeGrade1314</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="DoeGrade1314" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Rssfeedlink</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Rssfeedlink" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Doegrade1415</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Doegrade1415" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Doegrade1516</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Doegrade1516" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Doegrade1617</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Doegrade1617" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>WebScreenShotUrl</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="WebScreenShotUrl" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Description</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Description" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Doegrade1718</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Doegrade1718" />
                </mat-form-field>
            </div>
        </form>
    </div>

    <div class="spacer" fxFlex></div>

    <div class="error-messages" fxLayout="column" fxLayoutAlign="start end">
        <mat-error
            *ngIf="
                schoolEditorForm.controls['SchoolName'].invalid &&
                !schoolEditorForm.controls['SchoolName'].errors?.isNameTaken &&
                schoolEditorForm.controls['SchoolName'].touched
            "
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Please provide a name for the school.
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['SchoolName'].errors?.isNameTaken && schoolEditorForm.controls['SchoolName'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            School name chosen is already in use.
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['Phone'].errors?.maxlength && schoolEditorForm.controls['Phone'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['Phone'].errors?.maxlength.requiredLength }}
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['PhoneExt'].errors?.maxlength && schoolEditorForm.controls['PhoneExt'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['PhoneExt'].errors?.maxlength.requiredLength }}
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['Fax'].errors?.maxlength && schoolEditorForm.controls['Fax'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['Fax'].errors?.maxlength.requiredLength }}
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['_5digit'].errors?.maxlength && schoolEditorForm.controls['_5digit'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['_5digit'].errors?.maxlength.requiredLength }}
        </mat-error>
        <mat-error
            *ngIf="schoolEditorForm.controls['_5digit2'].errors?.maxlength && schoolEditorForm.controls['_5digit2'].touched"
        >
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Maximumn number of characters allowed is {{schoolEditorForm.controls['_5digit2'].errors?.maxlength.requiredLength }}
        </mat-error>
    </div>

    <div mat-dialog-actions align="end">
        <button mat-raised-button type="submit" color="primary" (click)="onSubmit(schoolEditorForm.value)">OK</button>
        <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
    </div>
</div>
